import connectUrl from 'commons/js/components/connectUrl'

import { DATETIME_FORMAT } from 'commons/js/constants'
import { maybeParseMoment, makeMinuteTimeSpan, makeHourTimeSpan } from 'commons/js/util/dateConverter'
import { calculateEndDay } from 'commons/js/services/dateCalculator'

import BookingAvailabilityContainer from './BookingAvailabilityContainer'

function mapParamsToProps (pathParams, queryParams) {
    const parkingId = pathParams.idParking
    const startDate = maybeParseMoment(queryParams.start_date, DATETIME_FORMAT)
    const endDate = calculateEndDay(
        startDate,
        maybeParseMoment(queryParams.end_date, DATETIME_FORMAT),
        makeHourTimeSpan(1),
        makeMinuteTimeSpan(10),
    )

    return {
        parkingId,
        startDate: startDate && startDate.unix(),
        endDate: endDate && endDate.unix(),
    }
}

export default connectUrl(mapParamsToProps)(BookingAvailabilityContainer)
